var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":"button"},on:{"click":_vm.onClickSearch}},[_c('IconSearch'),_c('span',[_vm._v(_vm._s(_vm.$t('search.button')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }